
import React, { useState } from "react";
import "../admin/AdminLogin.css";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(process.env.REACT_APP_API_URL+"/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        alert("✅ Login Successful!");
        // Save login session (JWT or user info)
        localStorage.setItem("adminInfo", JSON.stringify(data));
        // Redirect to admin dashboard
        window.location.href = "/admin/panel";
      } else {
        setError(data.message || "❌ Invalid credentials!");
      }
    } catch (err) {
      setError("⚠️ Server error. Please try again later.");
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <h2 className="admin-login-title">ADMIN LOGIN</h2>

        <form className="admin-login-form" onSubmit={handleSubmit}>
          <label>Mail id</label>
          <input
            type="email"
            placeholder="Enter your Mail id"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>Password</label>
          <input
            type="password"
            placeholder="Enter your Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {error && <p className="error-msg">{error}</p>}

          <button type="submit" className="admin-login-btn">
            LOGIN
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
